import { useMutation } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import { queryClient } from "api/tanStackQuery/queryClient";
import { GLOBAL_EVENT_QUERY_KEY } from "features/CenterContent/RoleContent/GlobalEvents/GlobalEventModal";
import { globalEventsQueryKey } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useGlobalInformation";
import { GlobalEventRequest } from "features/CenterContent/RoleContent/GlobalEvents/types/requestSchema";
import { GlobalEventResponse } from "features/CenterContent/RoleContent/GlobalEvents/types/responseSchema";

export const usePostGlobalInfo = (countryCode: string, uuid?: string) =>
  useMutation({
    mutationFn: (data: GlobalEventRequest) =>
      mutationFnPOST<GlobalEventResponse, GlobalEventRequest>(
        `${getBackendUrl()}/global-information${uuid ? `/${uuid}/change` : "/create"}`,
        data,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: globalEventsQueryKey(countryCode),
      });
      void queryClient.invalidateQueries({
        queryKey: [GLOBAL_EVENT_QUERY_KEY, uuid],
      });
    },
  });
